module.exports = "/static/assets/a52bc520f806137fa1d5b818b46c3bc1.png";